import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';
import Checkbox from '@ingka/checkbox';
import React from 'react';

interface CheckboxUpdateProfileType {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxUpdateProfile = ({
  checked,
  onChange,
}: CheckboxUpdateProfileType) => {
  const { t } = useTranslation();

  return (
    <Checkbox
      id="tos-updateProfileCheckbox"
      name="updateProfileCheckbox"
      type="checkbox"
      value=""
      checked={checked}
      onChange={onChange}
      label={t('orderForm.updateChangesOnProfile')}
    />
  );
};

export default CheckboxUpdateProfile;
